import React from 'react';
import { bool, func, array } from 'prop-types';

import Information from './information/';
import UploadAttachments from './upload-attachments/';
import {
  Title,
  Actions,
  FlexAlignCenter,
  AttachmentsCount,
  AttachmentHeaderWrap,
  AttachmentHeaderContainer,
} from './styled-components';


const AttachmentsHeader = (props) => {
  const {
    attachments, inModal, hideHeader, minView,
  } = props;

  return (
    <AttachmentHeaderWrap {...{ hideHeader }}>
      {!minView &&
      <div>
        <Title>Attachments</Title>
        <AttachmentsCount>[{attachments.length}]</AttachmentsCount>
      </div>}

      {minView &&
      <AttachmentHeaderContainer>
        <span>Attachments</span>
        <span> [{attachments.length}]</span>
      </AttachmentHeaderContainer>}


      <Actions>
        <Information inModal={inModal} />

        {props.onAttachmentsAdd ? (
          <FlexAlignCenter>
            <UploadAttachments {...props} />
          </FlexAlignCenter>
        ) : null}
      </Actions>
    </AttachmentHeaderWrap>
  );
};

AttachmentsHeader.propTypes = {
  isLoading: bool,
  openFilePicker: func,
  onAttachmentsAdd: func,
  attachments: array.isRequired,
  inModal: bool,
  hideHeader: bool,
  minView: bool,
};

AttachmentsHeader.defaultProps = {
  isLoading: false,
  openFilePicker: null,
  onAttachmentsAdd: null,
  inModal: false,
  hideHeader: false,
  minView: false,
};

export default AttachmentsHeader;



// WEBPACK FOOTER //
// ./src/components/attachments/header/index.js